// src/components/learning/LearningCourseCard.js

import { CourseCard } from "../components/CourseCard";
// Import Swiper components and modules
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import { CardCourseSkeleton } from "../../cards/skeletons/CardCourseSkeleton";

// This is the main component that will be exported
const NewCourse = ({ courses, loading }) => {
  return (
    <div className="w-full mx-auto mt-4">
      <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
        On Going Course
      </h2>

      {/* Swiper container for the course cards */}
      {loading || courses?.length ? (
        <div className="rounded-xl">
          <Swiper
            modules={[Navigation]}
            spaceBetween={16}
            slidesPerView={1}
            navigation
            breakpoints={{
              0: { slidesPerView: courses?.length > 1 ? 1.2 : 1 }, // for very small devices (mobile)
              480: { slidesPerView: courses?.length > 1 ? 1.5 : 1 }, // slightly wider phones
              640: { slidesPerView: 2 }, // small tablets
              768: { slidesPerView: courses?.length > 2 ? 2.2 : 2 }, // tablets
              1200: { slidesPerView: courses?.length > 3 ? 3.2 : 3 }, // desktops
            }}
            className="mt-4 md:mt-0 w-full h-full"
          >
            {/* Hide default navigation buttons if needed */}
            <style>{`
              .swiper-button-next,
              .swiper-button-prev {
                display: none !important;
              }
            `}</style>

            {/* Map through the courses and create a slide for each */}
            {loading
              ? [...Array(5)].map((_, idx) => (
                  <SwiperSlide key={idx}>
                    <CardCourseSkeleton />
                  </SwiperSlide>
                ))
              : courses.map((lesson) => (
                  <SwiperSlide key={lesson.id}>
                    <CourseCard lesson={lesson} className="min-h-[170px]" />
                  </SwiperSlide>
                ))}
          </Swiper>
        </div>
      ) : (
        <div className="flex justify-center italic items-center h-40 w-full text-sm p-3 text-center text-gray-400 bg-white rounded-xl">
          Your course list is empty. Pick a course to get started!
        </div>
      )}
    </div>
  );
};

export default NewCourse;
